import { AxiosResponse } from 'axios';
import { api } from 'src/common/utils';

import { CallRescueMonitorApiResponseType } from './types';

type ApiPayloadType = {
  currentPage: number;
  search: string;
  callRescueStatusFilter: number[];
};

export const fetchCallRescueMonitor = async (
  _: string,
  payload: ApiPayloadType
): Promise<AxiosResponse<CallRescueMonitorApiResponseType>> => {
  const { currentPage, search, callRescueStatusFilter } = payload;
  let queryParams = `?page=${currentPage}`;
  if (search) {
    queryParams += `&search=${search}`;
  }
  if (callRescueStatusFilter.length > 0) {
    queryParams += `&call_status=${callRescueStatusFilter.join(',')}`;
  }
  return api.get(`/call_rescue_monitor${queryParams}`);
};
